import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'react-loading';
import { Form } from 'semantic-ui-react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useMutation } from '@apollo/react-hooks';
import { Main, Button, Send } from './styles';
import { MdSend } from 'react-icons/md';
import { toast } from 'react-toastify';

import {
  ADD_MOTIVES,
  UPDATE_MOTIVE
} from '../../../services/graphql/mutations';

import { schema, formInitialState, formErrorInitialState } from './constants';

export default function Modal({
  edit,
  onClose,
  selectedValue,
  open,
  selected = {}
}) {
  const [{ motive, creation_date, active }, setFormState] = useState(
    formInitialState
  );
  const [{ motiveError, activeError }, setFormErrorState] = useState(
    formErrorInitialState
  );

  const [addMotive, { loading: addLoading }] = useMutation(ADD_MOTIVES);
  const [updateMotive, { loading: updateLoading }] = useMutation(UPDATE_MOTIVE);

  useEffect(() => {
    if (open) {
      setFormState(formInitialState);
      setFormErrorState(formErrorInitialState);
    }

    if (edit && open) {
      const { motive, creation_date, active } = selected;

      setFormState({
        motive,
        creation_date,
        active
      });
    }
  }, [open, edit, selected]);

  function handleOnChange(name, value) {
    setFormState(prevState => ({ ...prevState, [name]: value }));
  }

  async function handleSubmit() {
    try {
      setFormErrorState(formErrorInitialState);

      await schema.validate(
        { motive, creation_date, active },
        { abortEarly: false }
      );

      if (edit) {
        const editMotiveInput = {
          id: selected.id,
          motive,
          active,
          creation_date
        };

        await updateMotive({
          variables: {
            editMotiveInput
          }
        });
      } else {
        const motiveInput = {
          motive,
          active,
          creation_date
        };

        await addMotive({
          variables: {
            motiveInput
          }
        });
      }

      setFormState(formInitialState);

      let successMessage;

      if (edit) successMessage = 'El registro fue editado exitosamente';
      else successMessage = 'El registro fue creado exitosamente';

      toast.success(successMessage);

      handleClose();
    } catch (err) {
      if (err.inner) {
        err.inner.map(error =>
          setFormErrorState(prevState => ({
            ...prevState,
            [`${error.path}Error`]: true
          }))
        );
      } else {
        let errorMessage;

        if (edit) errorMessage = 'Error al intentar actualizar el registro';
        else errorMessage = 'Error al intentar crear el registro';

        toast.error(errorMessage);
      }
    }
  }

  function handleClose() {
    onClose(selectedValue);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {edit ? 'Editar' : 'Ingresar'} Motivos
      </DialogTitle>
      <Main data-testid="modal-component">
        <Form>
          <Form.Group>
            <Form.Input
              error={motiveError}
              label="Motivo *"
              placeholder="Motivo"
              width={12}
              value={motive}
              onChange={(e, { value }) => handleOnChange('motive', value)}
              className="plateInput"
            />
          </Form.Group>
          <Form.Group>
            <Form.Checkbox
              error={activeError}
              label="Activo"
              width={2}
              onClick={() => handleOnChange('active', !active)}
              checked={active}
            />
          </Form.Group>
        </Form>
        <Button onClick={handleSubmit} data-testid="send-button">
          {addLoading || updateLoading ? (
            <Loading height={15} width={15} type="spin" />
          ) : (
            <Send>
              <MdSend />
              Enviar
            </Send>
          )}
        </Button>
      </Main>
    </Dialog>
  );
}

Modal.propTypes = {
  edit: PropTypes.bool,
  onClose: PropTypes.func,
  selectedValue: PropTypes.any,
  open: PropTypes.bool,
  selected: PropTypes.object
};
